import * as SearchActions from './search.actions';

// This is the redux sub-store 'search' defined by the interface State and its reducer functions

/**
 * The interface defining the redux sub-store
 */
export interface State {
  searchAggregation: VehicleOfferSearchAggregation;
  searchParams: VehicleOfferSearchParams;
  finishedSearchParams: VehicleOfferSearchParams;
}

/**
 * The reducer acts on actions as defined below, and is the only way to update state
 * The JS spread operator for objects ('...') is used to update a given property of our state
 * while leaving the remaining properties of the state unchanged
 *
 * @param {State} state: the initial state of the redux sub-store
 * @param {SearchAction} action: the actions that this sub-store is managing
 * @returns {any} updated state of the redux sub-store
 */
export function searchReducer(state: State = {
  searchAggregation: undefined,
  searchParams: {} as any,
  finishedSearchParams: {
    'allPurchases': true,
    'highestBid': true,
    'onlyOffered': true,
    'purchaseNotReceived': true
  } as VehicleOfferSearchParams
},
action: SearchActions.SearchAction) {
  switch (action.type) {
  case SearchActions.UPDATED_SEARCH_AGGREGATION:
    return {
      ...state,
      searchAggregation: action.payload // update our stored searchAggregation with the action's payload
    };
  case SearchActions.UPDATE_SEARCH_PARAMS:
    return {
      ...state,
      searchParams: action.payload // update our stored searchParams with the action's payload
    };
  case SearchActions.DELETE_SEARCH_PARAMS:
    return {
      ...state,
      searchParams: {} as VehicleOfferSearchParams // reset searchParams
    };
  case SearchActions.UPDATE_FINISHED_SEARCH_PARAMS:
    return {
      ...state,
      finishedSearchParams: action.payload // update our stored finishedSearchParams with the action's payload
    };
  case SearchActions.DELETE_FINISHED_SEARCH_PARAMS:
    return {
      ...state,
      finishedSearchParams: {} as VehicleOfferSearchParams // reset finishedSearchParams
    };
  default:
    return state;
  }
}



